import { getDeepActionCBUrl, getDeepActionUrl } from "utils/common-methods";

export const createNewOrganizationDeepAction = (workspaceId: string) => {
    window.location.href= `${getDeepActionUrl()}/app/deep-actions/organization?workspace_id=${workspaceId}&callback_uri=${getDeepActionCBUrl()}`;
}